import { useMutation } from '@apollo/client'
import { useToast } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import {
  EXPORT_INFRINGEMENT,
  EXPORT_INFRINGEMENTS,
  EXPORT_INFRINGEMENTS_MASS,
  EXPORT_INFRINGEMENTS_USER_TOTALS,
} from '@/modules/exports/mutations'
import { useOnErrorAuto } from '@/utils/hooks'
import { PATCH_INFRINGEMENT_MUTATION } from '.'

export function useInfringementsMutations(onCompleted?: () => void) {
  const translations = useTranslate({
    success: 'infringements.send-email-success',
    downloadSuccess: 'exports.success-user-exports',
    exportTimeout: 'exports.export-timeout',
    error: 'exports.error-email-process',
  })

  const onErrorAuto = useOnErrorAuto()
  const addToast = useToast()

  const [toggleInfringementArchived, { loading: archiveInfringementLoading }] =
    useMutation(PATCH_INFRINGEMENT_MUTATION, {
      awaitRefetchQueries: true,
      refetchQueries: ['AllInfringements'],
      onError: onErrorAuto(),
    })

  const [toggleInfringementClosed, { loading: closedInfringementLoading }] =
    useMutation(PATCH_INFRINGEMENT_MUTATION, {
      awaitRefetchQueries: true,
      refetchQueries: ['AllInfringements'],
      onError: onErrorAuto(),
    })

  const [
    exportInfringementsUserSums,
    { loading: exportInfringementsUserSumsLoading },
  ] = useMutation(EXPORT_INFRINGEMENTS_USER_TOTALS, {
    onCompleted(data) {
      if (data?.exportInfringementsUserTotals.exportTimeout) {
        addToast('info', translations.exportTimeout)
      } else if (data?.exportInfringementsUserTotals.ok) {
        addToast('info', translations.downloadSuccess)
      }
      onCompleted?.()
    },
    onError: onErrorAuto(translations.error),
  })

  const [exportInfringements, { loading: exportInfringementsLoading }] =
    useMutation(EXPORT_INFRINGEMENTS, {
      onCompleted(data) {
        if (data?.exportInfringements.exportTimeout) {
          addToast('info', translations.exportTimeout)
        } else if (data?.exportInfringements.ok) {
          addToast('info', translations.downloadSuccess)
        }
        onCompleted?.()
      },
      onError: onErrorAuto(translations.error),
    })

  const [exportInfringementsMass, { loading: exportInfringementsMassLoading }] =
    useMutation(EXPORT_INFRINGEMENTS_MASS, {
      onCompleted(data) {
        if (data.exportInfringementsMass.ok) {
          addToast('info', translations.downloadSuccess)
        }
        onCompleted?.()
      },
      onError: onErrorAuto(translations.error),
    })

  const [exportInfringement, { loading: exportInfringementLoading }] =
    useMutation(EXPORT_INFRINGEMENT, {
      onCompleted(data) {
        if (data.exportInfringement.ok) {
          addToast('info', translations.downloadSuccess)
        }
        onCompleted?.()
      },
      onError: onErrorAuto(translations.error),
    })

  return {
    exportInfringement,
    exportInfringements,
    exportInfringementsMass,
    exportInfringementsUserSums,

    toggleInfringementArchived,
    toggleInfringementClosed,

    loading:
      exportInfringementsUserSumsLoading ||
      exportInfringementsLoading ||
      exportInfringementLoading ||
      archiveInfringementLoading ||
      exportInfringementsMassLoading ||
      closedInfringementLoading,
  }
}
